var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('footer-link-form',{attrs:{"footer-links":_vm.footerLinks,"is-editing":false},on:{"onSubmit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }